import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useGroupContext } from './context';
import { useGroupOverviewColumns } from '../../../../lib/components/tables/employee/columns';
import { EmployeeGroupTable } from '../../../../lib/components/tables/employee/employeeGroupTable';
import { Button } from '@mui/material';

export const GroupsDataView: FC = () => {
  const { t } = useTranslation();
  const { employeesInGroup, isLoadingInGroup, isFetchingInGroup, setMode } = useGroupContext();
  const columns = useGroupOverviewColumns();

  return (
    <EmployeeGroupTable
      data={employeesInGroup}
      columns={columns}
      isLoading={isLoadingInGroup}
      isFetching={isFetchingInGroup}
      columnVisibility={{ location: false, department: false, cost_center: false }}
      headline={t('company:EMPLOYEES_IN_GROUP')}
      additionalToolbarComponent={
        <Button variant="outlined" size="small" onClick={() => setMode('edit')}>
          {t('common:EDIT')}
        </Button>
      }
      className="max-w-[760px] w-full h-[calc(100vh-250px)] p-6"
    />
  );
};
